import { SelectOption } from '@/components/Form'
import { traingLogbookEnum } from './traingLogbookEnum'

const Status: SelectOption[] = [
  {
    value: traingLogbookEnum.Status.Submitted,
    label: 'Submitted'
  },
  {
    value: traingLogbookEnum.Status.Resubmitted,
    label: 'Resubmitted'
  },
  {
    value: traingLogbookEnum.Status.Endorsed,
    label: 'Endorsed'
  },
  {
    value: traingLogbookEnum.Status.Rejected,
    label: 'Rejected'
  }
]

export const traingLogbookOption = {
  Status
}
